import type { EditAsideTeaserImportance } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';
import SimpleRadioButton from '../../radioButton/SimpleRadioButton';
import AsideTeaserImportanceLabel from './asideTeaserImportanceLabel/AsideTeaserImportanceLabel';

export type TeaserImportance = 'LOW' | 'MEDIUM' | 'HIGH';

const AsideTeaserImportance: React.FC<{
  config: EditAsideTeaserImportance;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const initialValue = useInitialValue(config.property);

  const change = (value) => {
    dispatch(patchNodeAction(getResourceKey(editHref), set({}, config.property, value)));
  };

  return (
    <div>
      <label className="control-label" htmlFor="teaser-importance">
        {config.label}
      </label>
      <div className="importance" id="teaser-importance" style={{ display: 'flex' }}>
        {(['LOW', 'MEDIUM', 'HIGH'] as TeaserImportance[]).map((importance) => (
          <SimpleRadioButton
            key={importance}
            name={config.property}
            label={<AsideTeaserImportanceLabel importance={importance} />}
            value={importance}
            checked={initialValue === importance}
            onChange={change}
            readOnly={readonly}
          />
        ))}
      </div>
    </div>
  );
};

export default AsideTeaserImportance;

AsideTeaserImportance.displayName = 'AsideTeaserImportance';

AsideTeaserImportance.propTypes = {
  config: any,
  readonly: any,
};
